import { type Mode } from 'react-hook-form';

type formBaseConfigI = {
  mode: Mode;
};

export const formBaseConfig: formBaseConfigI = {
  mode: 'onBlur',
};
